import React from 'react';

interface IProps {
    children: React.ReactNode
}

const PublicLayout = ({ children }: IProps) => {
    return (
        <>
            {children}
        </>
    );
}

export default PublicLayout;